import O1HD from "../../../../engines/gameEngine";

export interface gamblerStartInterface{
    //id
    id:number,
    //图标
    icon:string,
    //档位
    gear:number,
    //重量
    weight:number,
    //描述
    explain:string,
    //价格
    price:number
}

export interface gamblerEndInterface{
    //木头id
    id:string,
    //木头类型id
    ys_id:string,
    //木头名字
    woodname:string,
    //级别
    level:string,
    //事件
    Emergency:number[],
    //是否一定触发概率
    certain:number,
    //切开后图片
    incision:number,
    //木头描述
    describe:string,
    //价格
    price:number,
    //概率
    pro:number,
    //属性
    param:{[name:string]:any},
}

export interface gamblerEventInterface{
    //id
    id:string,
    //事件类别
    event_category:number,
    //触发概率
    trigger_pro:number,
    //事件文案
    event_description:string,
    //事件选项1
    event_option1:string,
    //事件选项2
    event_option2:string,
    //选项1参数
    option1Param:{},
    //选项2参数
    option2Param:{},
    //结果文案
    result:string,
    //结果金钱
    result_money:number,
    //结果概率
    result_pro:number

}

export interface gamblerEventMap{
    [id:number]:gamblerEventInterface;
}

export interface gamblerStartMap{
    [id:number] : gamblerStartInterface;
}

export interface gamblerEndMap{
    [id:number] : gamblerEndInterface
}

export enum GamblerDataSaveType {
    GAMBLER_CUT_KEY = 'gambler-cut-key',
    GAMBLER_CUTCOUNT_DAY_KEY = 'gambler-cutcount-day-key',
    GAMBLER_SAVE_KEY = 'gambler-save-key',
    GAMBLER_DAT_SAVE_KEY = 'gambler-dat-save-key',
}

/** 藏宝图 */
export const TreasureMapCollect = [50024, 50025, 50026, 50027, 50028];